export var OnsiteSearchCriteria = {
    searchTerm: null,
    fromDate: moment().startOf('day'),
    thruDate: moment().endOf('day'),
    page: 0,
    size: 25
};
